import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "CalendarDialog",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      show: false,
      //
      isEdit: false,
      idArr: [],
      dateArr: [],
      itemArr: [],
      // null：正常， 1：休假， 2：上班
      isvacation: null
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    addDate: function addDate() {
      var _this = this;

      var obj = {};
      obj.ids = this.idArr.join(",");
      obj.datestr = this.dateArr.join(",");
      obj.isvacation = this.isvacation;
      var itemStr = [];

      var _iterator = _createForOfIteratorHelper(this.itemArr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item) {
            itemStr.push(item);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      obj.item = itemStr.join("&split&");
      this.loading = true;
      this.$http.post("/calendar/batcheSaveTag", JSON.stringify(obj), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == "0") {
          _this.$message.success(data.resMsg);

          _this.show = false;

          _this.$nextTick(function () {
            _this.$emit("init-page");
          });
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    editDate: function editDate() {
      var _this2 = this;

      var obj = {};
      obj.wid = this.idArr[0] == "*" ? "" : this.idArr[0];
      obj.currentdate = this.dateArr[0];
      obj.isvacation = this.isvacation;
      var itemStr = [];

      var _iterator2 = _createForOfIteratorHelper(this.itemArr),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          if (item) {
            itemStr.push(item);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      obj.item = itemStr.join("&split&");
      this.loading = true;
      this.$http.post("/calendar/saveTag", JSON.stringify(obj), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == "0") {
          _this2.$message.success(data.resMsg);

          _this2.show = false;

          _this2.$nextTick(function () {
            _this2.$emit("init-page");
          });
        }

        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    updata: function updata() {
      if (this.isEdit) {
        // 修改
        this.editDate();
      } else {
        // 批量
        this.addDate();
      }
    },
    showView: function showView(idArr, dateArr, itemArr, isvacation, isEdit) {
      var _this3 = this;

      this.idArr = idArr;
      this.dateArr = dateArr;
      this.itemArr = _toConsumableArray(itemArr);
      this.isvacation = isvacation;
      this.isEdit = isEdit;
      this.$nextTick(function () {
        _this3.show = true;
      });
    },
    changeItemArr: function changeItemArr(index) {
      if (index) {
        this.itemArr.splice(index, 1);
      } else {
        this.itemArr.push("");
      }
    }
  }
};